import 'whatwg-fetch';
import * as helpers from '../helpers';

/**
 *  Get you location address
 */
export default class Geocode {
    /**
     * Create geocode instance
     *
     * @param {Node} selector - selector for geocode button
     * @param {Object} options - geocode options
     */
    constructor(selector = '[data-geocode]', options) {
        this.selector = selector;
        this.input = null;
        this.geolocationSettings = {
            maximumAge: 50000,
            timeout: 20000,
            enableHighAccuracy: true,
        };

        this.options = {
            useOSMGeocoder: true,
            osmZoom: 18,
            useGoogleGeocoder: false,
            googleKey: window.location.origin.indexOf('stratis.fr') !== -1 || window.location.origin.indexOf('localhost') !== -1
                ? 'AIzaSyC6c3QpD7OJ-cREM-y8rDDzKCSQXbk5PS4' : null,
        };

        if (options instanceof Object) {
            this.options = helpers.extendDefaults(this.options, options);
        }

        this.checkBeforeInit();
    }

    checkBeforeInit() {
        if (typeof this.selector === 'string') {
            const elements = [].slice.call(document.querySelectorAll(this.selector));
            elements.forEach((element) => {
                const instance = new Geocode(element);
            });
        } else if (this.selector instanceof Element) {
            this.init();
        } else {
            throw new Error(`${this.selector} should be a DOM Object or string`);
        }
    }

    init() {
        this.input = this.selector.parentNode.querySelector('[data-geocode-field]');
        this.geocodeButtonHandler();
    }

    tryGeolocation() {
        // Use browser geolocation
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                this.handleSuccess.bind(this),
                this.handleError.bind(this),
                this.geolocationSettings,
            );
        } else {
            alert('Votre navigateur ne prend pas en charge la géolocalisation. Veuillez le mettre à jour ou utiliser un navigateur plus récent.');
        }
    }

    getGeolocationAddress(position) {
        // Use google Geocoder
        if (this.options.useGoogleGeocoder) {
            if (this.options.googleKey === null) {
                throw new Error('Your google API key is invalid');
            }

            // Get data from google api
            fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.lat},${position.lng}&key=${this.options.googleKey}`, {
                method: 'GET',
            })
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        // if status OK return response text
                        return response.text();
                    }

                    // or throw error
                    throw new Error(response.statusText);
                })
                .then((response) => {
                    // conver text from response to JSON
                    const responseData = JSON.parse(response);

                    if (responseData.status !== 'OK' || !responseData.results.length) {
                        // if we have troubles with api KEY (example QUERY_LIMITS) throw error
                        throw new Error(responseData.error_message);
                    }

                    // or return location information
                    return responseData.results[0];
                })
                .then((results) => {
                    if (this.input === null) {
                        // throw error if we haven't field to ouput information
                        throw new Error('Can\'t find input with [data-geocode-field] parameter, it shoud be in one wrapper with data-geocode button');
                    }

                    // paste address to input field
                    this.input.value = results.formatted_address;
                });
        }

        // Use OSM geocoder
        if (this.options.useOSMGeocoder) {
            // get data from OSM api
            fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${position.lat}&lon=${position.lng}&zoom=${this.options.osmZoom}&addressdetails=1`, {
                method: 'GET',
            })
                .then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        // If status OK return JSON
                        return response.json();
                    }

                    // Or throw error
                    throw new Error(response.statusText || 'Invalid query URL');
                })
                .then((results) => {
                    if (this.input === null) {
                        // throw error if we haven't field to ouput information
                        throw new Error('Can\'t find input with [data-geocode-field] parameter, it shoud be in one wrapper with data-geocode button');
                    }

                    // paste address to input field
                    this.input.value = results.display_name;
                });
        }
    }

    handleSuccess(position) {
        this.getGeolocationAddress({ lat: position.coords.latitude, lng: position.coords.longitude });
    }

    handleError(error) {
        switch (error.code) {
            case error.TIMEOUT:
                alert('Votre géolocalisation prend trop de temps. Veuillez recommencer ultérieurement.');
                break;
            case error.POSITION_UNAVAILABLE:
                alert('La géolocalisation n\'est pas disponible sur votre navigateur. Rechargez la page et autorisez la géolocalisation lorsqu\'elle vous sera demandées.');
                break;
            default:
                console.warn(`ERROR(${error.code}): ${error.message}`);
        }
    }

    geocodeButtonHandler() {
        // Bind click on the button
        this.selector.addEventListener('click', this.tryGeolocation.bind(this));
    }
}
